const readAscii = (bytes, start, length) => (
  String.fromCharCode(...bytes.slice(start, start + length))
);

const readJpegDimensions = (view) => {
  let offset = 2;
  while (offset + 8 < view.byteLength) {
    if (view.getUint8(offset) !== 0xff) break;
    const marker = view.getUint8(offset + 1);
    const length = view.getUint16(offset + 2);
    if ([0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf].includes(marker)) {
      return { width: view.getUint16(offset + 7), height: view.getUint16(offset + 5) };
    }
    if (length < 2) break;
    offset += length + 2;
  }
  return null;
};

export const readCareSourceImageDimensions = async (file) => {
  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  const view = new DataView(buffer);

  if (bytes.length >= 24 && readAscii(bytes, 1, 3) === 'PNG') {
    return { width: view.getUint32(16), height: view.getUint32(20) };
  }
  if (bytes.length >= 10 && bytes[0] === 0xff && bytes[1] === 0xd8) {
    return readJpegDimensions(view);
  }
  for (let offset = 4; offset + 16 < bytes.length; offset += 1) {
    if (readAscii(bytes, offset, 4) === 'ispe') {
      return { width: view.getUint32(offset + 8), height: view.getUint32(offset + 12) };
    }
  }
  return null;
};
